export default __webpack_public_path__ + "static/media/c.7367d235.jpg";